import { render, staticRenderFns } from "./ScoreDebug.vue?vue&type=template&id=4923ae3f&scoped=true&"
import script from "./ScoreDebug.vue?vue&type=script&lang=js&"
export * from "./ScoreDebug.vue?vue&type=script&lang=js&"
import style0 from "./ScoreDebug.vue?vue&type=style&index=0&id=4923ae3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4923ae3f",
  null
  
)

export default component.exports